<div class="mw-100" style="background-color: white; height: 100%;">
    <app-navbar></app-navbar>
    <div class="container">
        <div class="button">
            <button class="p-button p-component btn" (click)="regresar(deviceUrl, deviceName)">Menu</button>
        </div>    
      <p-table  [value]="campaigns" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>{{ 'ID_CAMPAIGNS' | translate}}</th>
                <th>{{ 'NAME_CAMPAIGNS' | translate}}</th>
                <th>{{ 'START_CAMPAIGNS' | translate}}</th>
                <th>{{ 'END_CAMPAIGNS' | translate}}</th>
                <th>{{ 'STATUS_CAMPAIGNS' | translate}}</th>
                <th>{{ 'DETAILS_CAMPAIGNS' | translate}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-campaign of campaigns>
            <tr>
                <td>{{campaign.id}}</td>
                <td>{{campaign.nombreCampania}}</td>
                <td>{{campaign.fechaHoraInicio | date: 'dd/MM/YYYY'}}</td>
                <td>{{campaign.fechaHoraFin | date: 'dd/MM/YYYY'}}</td>
                <td>{{campaign.estatusCampania}}</td>
                <td><i class="pi pi-arrow-right icon-table-custom"
                    pTooltip="{{ 'DETAILS_CAMPAIGNS' | translate}}" (click)="detalles(campaign.id, deviceUrl, deviceName)"></i></td>
            </tr>
        </ng-template>        
    </p-table>
    <div *ngIf="!campaigns || campaigns.length === 0" class="text-center mt-3">
        <p class="vacio">{{ 'TABLE_EMPTY' | translate}}</p>
    </div>
    </div>
</div>